import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import React, { useState, useEffect } from 'react'
import StepperDialog from 'components/modal/StepperDialog'
import { IMPORT_TYPE, IMPORT_TYPE_TRAITEMENT, CITIES, STATIONS, DEPARTMENTS, IMPORT, EXPORT, ALERTE, CALCUL, STEPS, OTHER } from 'traitements/constants/TraitementConstants'
import AddTreatementStepTreatment from './AddTreatementStepTreatment'
import AddTreatementStepActionTreatment from './AddTreatementStepActionTreatment'
import { Button, Typography } from '@mui/material'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import AddHydroStepStation from './addHydro/AddHydroStepStation'
import AddPiezoStepStation from './addPiezo/AddPiezoStepStation'
import AddPluvioStepStation from './addPluvio/AddPluvioStepStation'
import AddQualitoStepStation from './addQualito/AddQualitoStepStation'
import AddHydroStepOptions from './addHydro/AddHydroStepOptionsTreatmentHP'
import AddHydroStepOptionsMareGraphe from './addHydro/AddHydroStepOptionsTreatmentMareGraphe'
import AddHydroStepOptionsOndes from './addHydro/AddHydroStepOptionsTreatmentOndes'
import AddPiezoStepOptions from './addPiezo/AddPiezoStepOptionsTreatmentAdes'
import AddPluvioStepOptions from './addPluvio/AddPluvioStepOptionsTreatmentMF'
import AddPluvioStepOptionsArea from './addPluvio/AddPluvioStepOptionsTreatmentArea'
import AddPluvioStepOptionsRadar from './addPluvio/AddPluvioStepOptionsTreatmentMFRadar'
import AddPluvioStepOptionsERA5 from './addPluvio/AddPluvioStepOptionsTreatmentERA5'
import AddAdesQalitoStepOptions from './addQualito/AddQualitoStepOptionsTreatmentAdes'
import AddNAIADESStepOptions from './addQualito/AddQualitoStepOptionsTreatmentNaiades'
import AddOROBNATStepOptions from './addQualito/AddQualitoStepOptionsTreatmentOrobnat'
import { darkBlue } from 'utils/constants/ColorTheme'
import { nameCorrect, sizeCorrect, save } from './SaveTreatment'
import AddOtherStep from './addOther/AddOtherStep'


const STEP = {
    TRAITEMENT: 0,
    TRAITEMENT_TYPE: 1,
    TYPE: 2,
    OPTIONS: 3,
}
const ACTION_TREATEMENT_COMPONENTS = {
    [IMPORT]: AddTreatementStepTreatment,
    [EXPORT]: AddOtherStep,
    [ALERTE]: AddOtherStep,
    [CALCUL]: AddOtherStep,
    [OTHER]: AddOtherStep,
}
const CONFIG = [
    {
        types: [IMPORT_TYPE.HYDRO_PORTAIL, IMPORT_TYPE.LOW_WATER_ONDE, IMPORT_TYPE.TIDE_GAUGE],
        station: AddHydroStepStation,
    },
    {
        types: [IMPORT_TYPE.PIEZO_PORTAIL],
        station: AddPiezoStepStation,
    },
    {
        types: [IMPORT_TYPE.PLUVIO_PORTAIL, IMPORT_TYPE.ERA5, IMPORT_TYPE.PLUVIO_EMPRISE, IMPORT_TYPE.METEO_FRANCE_RADAR],
        station: AddPluvioStepStation,
    },
    {
        types: [IMPORT_TYPE.QUALITO, IMPORT_TYPE.NAIADES, IMPORT_TYPE.ADES_QUALITO, IMPORT_TYPE.OROBNAT],
        station: AddQualitoStepStation,
    },
    {
        types: [IMPORT_TYPE.OTHER],
        station: AddOtherStep,
    },
]
const STATION_TYPE_COMPONENTS = Object.fromEntries(
    CONFIG.flatMap(({ types, station }) =>
        types.map(type => [type, station]),
    ),
)


const STATION_OPTION_COMPONENTS = {
    [IMPORT_TYPE_TRAITEMENT.HYDRO_PORTAIL]: AddHydroStepOptions,
    [IMPORT_TYPE_TRAITEMENT.LOW_WATER_ONDE]: AddHydroStepOptionsOndes,
    [IMPORT_TYPE_TRAITEMENT.TIDE_GAUGE]: AddHydroStepOptionsMareGraphe,

    [IMPORT_TYPE_TRAITEMENT.PIEZO_PORTAIL]: AddPiezoStepOptions,

    [IMPORT_TYPE_TRAITEMENT.PLUVIO_PORTAIL]: AddPluvioStepOptions,
    [IMPORT_TYPE_TRAITEMENT.ERA5]: AddPluvioStepOptionsERA5,
    [IMPORT_TYPE_TRAITEMENT.PLUVIO_EMPRISE]: AddPluvioStepOptionsArea,
    [IMPORT_TYPE_TRAITEMENT.METEO_FRANCE_RADAR]: AddPluvioStepOptionsRadar,

    [IMPORT_TYPE_TRAITEMENT.ADES_QUALITO]: AddAdesQalitoStepOptions,
    [IMPORT_TYPE_TRAITEMENT.NAIADES]: AddNAIADESStepOptions,
    [IMPORT_TYPE_TRAITEMENT.OROBNAT]: AddOROBNATStepOptions,

    [IMPORT_TYPE_TRAITEMENT.OTHER]: AddOtherStep,
}

const AddTraitementsStepper = ({
    isOpen,
    setIsOpen,
    initialStep,
    initialAction,
    initialType,
}) => {
    const dispatch = useDispatch()

    const [station, setStation] = useState({ stationType: initialType })
    const [actiontreatement, setactiontreatement] = useState(initialAction)
    const [filters, setFilters] = useState({})
    const [jobDataTypes, setJobDataTypes] = useState([])
    const [typeJob, setTypeJob] = useState('')
    const changeStation = (changes) => setStation({ ...station, ...changes })
    const changeFilters = changes => setFilters({ ...filters, ...changes })

    const [listStation, setListStation] = useState([
        [STATIONS, []],
        [CITIES, []],
        [DEPARTMENTS, []],
    ])
    const initialJob = { ...station.job, id: null, name: null }
    const [newJob, setNewJob] = useState(initialJob)

    useEffect(() => {
        setNewJob({ ...station.job, id: null, name: null })
    }, [station.job])


    const [choices, setChoices] = useState({
        TRAITEMENT: '',
        TRAITEMENT_TYPE: '',
        TYPE: '',
        OPTIONS: '',
    })
    const stepsOrder = [STEPS.TRAITEMENT, STEPS.TRAITEMENT_TYPE, STEPS.TYPE, STEPS.OPTIONS]

    const resetAfterStep = (step) => {
        const index = stepsOrder.indexOf(step)

        setChoices(prev => ({
            ...prev,
            ...Object.fromEntries(
                stepsOrder.slice(index).map(key => [key, '']),
            ),
        }))
    }

    useEffect(() => {
        if (initialStep === 2) {
            setChoices(prev => ({
                ...prev,
                TRAITEMENT: initialAction === '' ? '' : `(${IMPORT})`,
                TRAITEMENT_TYPE: initialType===IMPORT_TYPE.HYDRO_PORTAIL ? `(${i18n.hydroStation})`
                    : initialType===IMPORT_TYPE.PLUVIO_PORTAIL? `(${i18n.pluviometry})`
                        : initialType===IMPORT_TYPE.QUALITO? `(${i18n.quality})`
                            : initialType===IMPORT_TYPE.PIEZO_PORTAIL? `(${i18n.piezometry})` : '',
            }))
        } else {
            resetAfterStep('TRAITEMENT')
        }
    }, [initialStep])

    return (
        <StepperDialog
            defaultStep={initialStep}
            steps={[
                {
                    label: (
                        <>
                            {i18n.actionTreatement}{' '}
                            <Typography sx={{ fontStyle: 'italic', fontSize: '8px', color: darkBlue }}>
                                {choices.TRAITEMENT}
                            </Typography>
                        </>
                    ),
                    constant: STEP.TRAITEMENT,
                    nextAvailable: !!station.stationType,
                    onChangeStep: () => resetAfterStep('TRAITEMENT'),

                },
                {
                    label: (
                        <>
                            {i18n.job}{' '}
                            <Typography sx={{ fontStyle: 'italic', fontSize: '8px', color: darkBlue }}>
                                {choices.TRAITEMENT_TYPE}
                            </Typography>
                        </>
                    ),
                    constant: STEP.TRAITEMENT_TYPE,
                    nextAvailable: !!station.stationType,
                    onChangeStep: () => resetAfterStep('TRAITEMENT_TYPE'),
                },
                {
                    label: (
                        <>
                            {i18n.jobType}{' '}
                            <Typography sx={{ fontStyle: 'italic', fontSize: '8px', color: darkBlue }}>
                                {choices.TYPE}
                            </Typography>
                        </>
                    ),
                    constant: STEP.TYPE,
                    nextAvailable: !!station.stationType && station.stationType != IMPORT_TYPE.OTHER,
                    onChangeStep: () => resetAfterStep('TYPE'),

                },
                {
                    label: i18n.options,
                    constant: STEP.OPTIONS,
                },
            ]}

            open={isOpen}
            title={i18n.addOrUpdateStation}
            closeDialog={() => setIsOpen(false)}

            renderSaveButton={(step, resetStep) => {
                return step === STEP.OPTIONS && sizeCorrect(listStation) && nameCorrect(newJob.name) &&(
                    <Button
                        variant='contained'
                        startIcon={<NoteAddIcon/>}
                        onClick={() => save(listStation, newJob, STEP, step, station, filters, dispatch, setNewJob,
                            initialJob, resetStep, setStation, setFilters, setJobDataTypes)}
                    >
                        {i18n.save}
                    </Button>
                )
            }}
        >
            {(step, nextStep) => {
                const params = { setIsOpen, station, changeStation, filters, changeFilters,
                    setFilters, nextStep, jobDataTypes, setJobDataTypes, newJob, setNewJob,
                    listStation, setListStation, actiontreatement, setactiontreatement, setChoices, typeJob, setTypeJob }
                switch (step) {
                    case STEP.TRAITEMENT:
                        return <AddTreatementStepActionTreatment {...params} />
                    case STEP.TRAITEMENT_TYPE:
                        const ActionTreatementComponent = ACTION_TREATEMENT_COMPONENTS[actiontreatement]
                        return <ActionTreatementComponent {...params} />
                    case STEP.TYPE:
                        const StationComponent = STATION_TYPE_COMPONENTS[station.stationType]
                        return <StationComponent {...params} />
                    case STEP.OPTIONS:
                        const StationOptionComponent = STATION_OPTION_COMPONENTS[station.stationType]
                        return <StationOptionComponent {...params} />
                    default:
                        return <AddTreatementStepActionTreatment {...params} />
                }
            }}
        </StepperDialog>
    )
}

AddTraitementsStepper.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    initialStep: PropTypes.any,
    initialAction: PropTypes.string,
    initialType: PropTypes.string,
}

export default AddTraitementsStepper